import React from 'react';
import { ctaPropTypes } from './CtaPropTypes';
import Container from '@Theme/natucare/components/Container/Container';
import Button from '@Theme/natucare/components/Button/Button';
import Icon from '@Theme/natucare/components/Icon/Icon';
import Picture from '@Theme/natucare/components/Picture/Picture';
import * as styles from './Cta.module.scss';
const Cta = ({
  heading,
  description,
  button,
  picture
}) => {
  var _picture$xs;
  if (!heading && !description && !button && !picture) {
    return null;
  }
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Container, {
    classname: styles.rootContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootMain
  }, (picture === null || picture === void 0 ? void 0 : (_picture$xs = picture.xs) === null || _picture$xs === void 0 ? void 0 : _picture$xs.src) && /*#__PURE__*/React.createElement(Picture, {
    alt: picture.alt,
    xs: {
      src: picture.xs.src
    },
    sm: {
      srcSet: picture.md.src
    },
    pictureClassname: styles.rootPicture,
    imgClassname: styles.rootImage
  }), /*#__PURE__*/React.createElement(Icon, {
    name: "ctaHeart",
    classname: styles.rootIcon,
    size: {
      width: 42,
      height: 39
    }
  }), heading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootHeading
  }, heading), description && /*#__PURE__*/React.createElement("p", {
    className: styles.rootDescription
  }, description), (button === null || button === void 0 ? void 0 : button.label) && (button === null || button === void 0 ? void 0 : button.href) && /*#__PURE__*/React.createElement(Button, {
    label: button.label,
    href: button.href,
    classname: styles.rootButton
  }))));
};
export default Cta;